import VFileBrowserTree from './VFileBrowserTree';
import { VFileBrowserTreeLoading } from './VFileBrowserTreeLoading';
import { useFileBrowserContext } from './context';

export const VFileBrowserTreeBoundary = () => {
  const { loadingTree } = useFileBrowserContext();

  return loadingTree ? <VFileBrowserTreeLoading /> : <VFileBrowserTree />;
};
